var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#287268"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.687 17.8466C9.545 18.7759 10.179 19.4206 10.955 19.7419C13.9303 20.9753 18.0703 20.9753 21.0457 19.7419C21.8217 19.4206 22.4557 18.7753 22.3137 17.8466C22.227 17.2753 21.7957 16.7999 21.4763 16.3353C21.0583 15.7193 21.017 15.0479 21.0163 14.3333C21.017 11.5719 18.7717 9.33325 16.0003 9.33325C13.229 9.33325 10.9837 11.5719 10.9837 14.3333C10.9837 15.0479 10.9423 15.7199 10.5237 16.3353C10.205 16.7999 9.77433 17.2753 9.687 17.8466Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 20.6665C13.6393 21.8165 14.718 22.6665 16.0007 22.6665C17.284 22.6665 18.3613 21.8165 18.6673 20.6665",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmGreen);
export default __webpack_public_path__ + "static/media/alarm-green.8e17719372ed8351862095d1749398bc.svg";
export { ForwardRef as ReactComponent };